// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1fnyj","alert":"SettungsInbox_alert__1jB9V"};